module.exports = "/_next/static/images/d12ddd644c620b0f04f863c09d6fbe76-stapler@desktop1024.jpg";